import { lang } from '@ott/l10n';

export default function getMaxDate() {
  let daysAmount = 120;

  if (lang === 'ru-kz') {
    daysAmount = 60;
  }

  const todayDate = new Date();
  const maxDate = new Date(
    todayDate.setDate(todayDate.getDate() - 1) + daysAmount * 24 * 60 * 60 * 1000
  );

  return maxDate;
}
